import React from "react";
import { Box, Button, Typography } from "@mui/material";

export default function PermissionDenied() {
  return (
    <Box
      sx={{
        height: "80vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box sx={{}}>
        <Typography variant="h1" component="div" gutterBottom sx={{ mb: 2 }}>
          403
        </Typography>
        <Typography variant="h6" component="div" gutterBottom sx={{ mb: 2 }}>
          access not granted
        </Typography>
        <Typography
          variant="subtitle1"
          component="div"
          gutterBottom
          sx={{ mb: 2 }}
        >
          Please Contact your Administrator!
        </Typography>
        <Button variant="outlined" href="/">
          Back To Home
        </Button>
      </Box>
    </Box>
  );
}
